<template>
  <NAvatar
    src="/images/avatar.png"
    skeleton
  />
</template>
